import type { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import {
  CreditValue,
  PanelChoiceRow,
  PanelLinkRow,
  PanelValueRow,
} from '@/components/settings/panel-rows'

export type StudiesSubPage = 'subjects' | 'averages' | 'exams' | 'lecturers'

interface MyStudiesTabProps {
  onOpen: (page: StudiesSubPage) => void
}

/**
 * My Studies tab — Figma `panel` content (2276:296918 and the
 * 1200/900/600/400 frames).
 *
 * Figures are placeholders until the study endpoint exists; the row shapes
 * come straight from the design.
 */
export function MyStudiesTab({ onOpen }: MyStudiesTabProps): ReactElement {
  const { t } = useTranslation()

  return (
    <>
      <PanelChoiceRow label={t('studies.switchMajor')} value={t('studies.majorPlaceholder')} />

      <PanelValueRow
        label="2025/26/2"
        value={<CreditValue amount="—" suffix={t('studies.cr')} />}
      />
      <PanelValueRow
        label={t('studies.fullProgram')}
        value={<CreditValue amount="—" suffix={t('studies.cr')} />}
      />
      <PanelValueRow
        label={t('studies.byCurriculum')}
        value={<CreditValue amount="—" suffix={t('studies.cr')} />}
      />
      <PanelValueRow
        label={t('studies.finishedSemesters')}
        value={<CreditValue amount="—" suffix={t('studies.cr')} />}
      />
      <PanelValueRow
        label={t('studies.semesterAverage', { semester: '2025/26/1' })}
        value={<span className="hub-title-lg-highlight text-list-text">—</span>}
      />
      <PanelValueRow
        label={t('studies.weightedAverage')}
        value={<span className="hub-title-lg-highlight text-list-text">—</span>}
      />

      <PanelLinkRow
        label={t('studies.subjects')}
        onOpen={() => {
          onOpen('subjects')
        }}
      />
      <PanelLinkRow
        label={t('studies.averages')}
        onOpen={() => {
          onOpen('averages')
        }}
      />
      <PanelLinkRow
        label={t('studies.exams')}
        onOpen={() => {
          onOpen('exams')
        }}
      />
      <PanelLinkRow
        last
        label={t('studies.lecturers')}
        onOpen={() => {
          onOpen('lecturers')
        }}
      />
    </>
  )
}
